import Image from "next/image";
import Link from "next/link";
import { Heading } from "@/components/ui/Heading";
import { BannerData } from "@/core/types/about-us";
import { loadThemeComponent } from "@/core/config/theme-component-loader";
const CustomButton = loadThemeComponent("CustomButton")

interface BannerProps {
  data: BannerData;
}

export default function Banner({ data }: BannerProps) {

  return (
    <div className="col-span-12 relative w-full h-56 lg:h-60 flex items-center justify-center p-8">
      {data.image && (
        <Image
          src={data.image?.url}
          alt={data.title || "some picture"}
          className="absolute w-full h-full object-cover"
          fill
        />
      )}
      <div className="absolute inset-0 bg-black/40 z-0" />
      <div className="absolute text-center space-y-4">
        <Heading
          level={1}
          className="text-primary-0 text-[calc(1rem+0.3vw)]"
        >
          {data.title}
        </Heading>
        <Heading
          level={3}
          className="text-primary-0"
        >
          {data?.description}
        </Heading>
        {(data.buttonContent && data.link) && <CustomButton variant="transparentWhite" asChild className="bg-transparent">
          <Link href={data.link}>{data.buttonContent}</Link>
        </CustomButton>}
      </div>
    </div>
  );
}
